import { sva } from "@agapi/ui/panda/css";
import { anatomy } from "@zag-js/number-input";
export const quantitySelectorStyles = sva({
    slots: anatomy.extendWith('trigger').keys(),
    base: {
        root: {
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            color: 'surface.default.foreground',
            borderColor: 'forms.action',
            borderWidth: '1px',
            rounded: 'forms',
            width: 'auto',
            background: 'surface.default.background',
        },
        input: {
            textAlign: 'center',
            fontWeight: 'bold',
            color: 'text.body',
            fontSize: 'sm',
            minWidth: 'items.sm',
            flexGrow: '1',
            '&::-webkit-inner-spin-button': {
                display: 'none'
            },
            _focus: {
                outline: 'none'
            },
            _disabled: {
                color: 'grey.400',
            }
        },
        trigger: {
            backgroundColor: 'surface.base.background',
            color: 'surface.base.foreground',
            borderRadius: 'forms',
            _hover: {
                backgroundColor: 'surface.base.background',
                color: 'surface.base.foreground',
            },
            _disabled: {
                //backgroundColor: 'action.disabled.background',
                color: 'grey.200',
            }
        }
    },
    variants: {
        disabled: {
            true: {
                root: {
                    borderColor: 'grey.200',
                    color: 'grey.300',
                }
            }
        }
    }
});
